import { render, staticRenderFns } from "./RewardsSettings.vue?vue&type=template&id=051e1aed&scoped=true&"
import script from "./RewardsSettings.vue?vue&type=script&setup=true&lang=js&"
export * from "./RewardsSettings.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RewardsSettings.vue?vue&type=style&index=0&id=051e1aed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051e1aed",
  null
  
)

export default component.exports